<template>
  <div>
    <!-- 标题 -->
    <ots-main-title></ots-main-title>
    <div class="content">
      <el-form
        :model="form"
        label-width="160px"
        :inline="true"
        ref="form"
        :rules="rules"
      >
        <!------- 标题 ------->
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>

        <!------- 有效时间 ------->
        <div>
          <el-form-item label="有效时间" prop="validStartDate">
            <el-date-picker
              :value-format="dataFormat"
              v-model="form.validStartDate"
              :picker-options="pickerOptions"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            至
          </el-form-item>
          <el-form-item label="" prop="validEndDate">
            <el-date-picker
              :default-time="defaultTime"
              :value-format="dataFormat"
              v-model="form.validEndDate"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </div>

        <!------- 输入内容(UEditor) ------->
        <div>
          <el-form-item label="内容" prop="content">
            <ots-editor class="editor" v-model="form.content" />
          </el-form-item>
        </div>

        <!------- 公告显示形式 ------->
        <div>
          <el-form-item label="公告显示形式">
            <el-radio-group v-model="form.noticeShow" class="df-ac pr">
              <el-radio-button label="0">列表显示</el-radio-button>
              <el-radio-button label="1">弹窗显示一次</el-radio-button>
              <el-radio-button label="3">登录页公告显示</el-radio-button>
              
              <el-tooltip
                popper-class="tipIndex20"
                manual
                v-model="isShowNoticeTip"
                content="建议十分紧急通知启用该弹窗方式"
                placement="right"
              >
                <!-- <el-radio-button label="2">弹窗一直显示</el-radio-button> -->
              </el-tooltip>
            </el-radio-group>
          </el-form-item>
        </div>

        <!------- 发布对象(学生) ------->
        <div v-show="form.noticeShow != 3">
          <el-form-item label="发布对象" style="display:block;">
            <!-- :disabled="roleType != 1" -->
            <el-checkbox
              v-model="form.student"
              :true-label="1"
              :false-label="0"
              @change="changeStudent"
            />
            学生
            <!------- 考试批次 ------->
            <div v-if="disStudent">
              <el-form-item label="考试批次" label-width="80px">
                <el-select v-model="form.examBatch" placeholder="请选择">
                  <el-option
                    v-for="item in planData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <!------- 审核状态 ------->
            <div v-if="disStudent">
              <el-form-item label="审核状态" label-width="80px">
                <el-select
                  v-model="form.auditStatus"
                  placeholder="请选择"
                  :disabled="isUseAudit"
                >
                  <el-option
                    v-for="item in auditData"
                    :key="item.name"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <!------- 缴费情况 ------->
            <div v-if="disStudent">
              <el-form-item label="缴费情况" label-width="80px">
                <el-select
                  v-model="form.payStatus"
                  placeholder="请选择"
                  :disabled="isUseAudit"
                >
                  <el-option
                    v-for="item in payData"
                    :key="item.name"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <!------- 学生--教学点(必选项) ------->
            <div v-if="disStudent">
              <el-form-item
                label="教学点"
                label-width="80px"
                prop="studentDealStation"
              >
                <div class="stationBox">
                  <div class="stationTop">
                    <el-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="CheckAllStudentStation"
                      :disabled="disStation"
                      >全选</el-checkbox
                    >
                    <div class="searchCourse ml30">
                      <el-input
                        placeholder="快捷搜索"
                        v-model="studentStationStr"
                        :disabled="disStation"
                      ></el-input>
                      <div class="searchPos">
                        <i class="iconfont icon-sousuo"></i>
                      </div>
                    </div>
                  </div>
                  <div class="station-container">
                    <el-checkbox-group
                      v-model="form.studentDealStation"
                      @change="CheckedStudentStations"
                      :disabled="disStation"
                    >
                      <el-checkbox
                        v-for="station in stationSelectData"
                        :label="station.id"
                        :key="station.id"
                        :title="station.name"
                        >{{ station.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
              </el-form-item>
            </div>
            <!------- 学生--院校(必选项) ------->
            <div style="margin-top:16px;" v-if="disStudent">
              <el-form-item
                label="院校"
                label-width="80px"
                prop="studentSchool"
              >
                <div class="stationBox">
                  <div class="stationTop">
                    <el-checkbox
                      :indeterminate="isIndeterminateStudentSchool"
                      v-model="checkAllStudentSchool"
                      @change="CheckAllStudentSchoolFN"
                      :disabled="disSchool"
                      >全选</el-checkbox
                    >
                    <div class="searchCourse ml30">
                      <el-input
                        placeholder="快捷搜索"
                        v-model="studentSchoolStr"
                        :disabled="disSchool"
                      ></el-input>
                      <div class="searchPos">
                        <i class="iconfont icon-sousuo"></i>
                      </div>
                    </div>
                  </div>
                  <div class="station-container">
                    <el-checkbox-group
                      v-model="form.studentSchool"
                      @change="CheckedStudentSchools"
                      :disabled="disSchool"
                    >
                      <el-checkbox
                        v-for="school in schoolSelectData"
                        :label="school.id"
                        :key="school.id"
                        :title="school.name"
                        >{{ school.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form-item>

          <!-- 发布对象 : 教学点管理员 -->
          <el-form-item label=" " v-if="roleType == 1">
            <el-checkbox
              v-model="form.dealStationCustodian"
              :true-label="1"
              :false-label="0"
            />
            教学点管理员
            <div v-if="form.dealStationCustodian == 1">
              <el-form-item label="教学点" label-width="80px">
                <div class="stationBox">
                  <div class="stationTop">
                    <el-checkbox
                      :indeterminate="isIndeterminateStation"
                      v-model="checkAllStation"
                      @change="CheckAllStationFN"
                      >全选</el-checkbox
                    >
                    <div class="searchCourse ml30">
                      <el-input
                        placeholder="快捷搜索"
                        v-model="stationStr"
                      ></el-input>
                      <div class="searchPos">
                        <i class="iconfont icon-sousuo"></i>
                      </div>
                    </div>
                  </div>
                  <div class="station-container">
                    <el-checkbox-group
                      v-model="form.dealStation"
                      @change="CheckedStations"
                    >
                      <el-checkbox
                        v-for="station in stationDataList"
                        :label="station.id"
                        :key="station.id"
                        :title="station.name"
                        >{{ station.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form-item>

          <!------- 院校管理员--院校 ------->
          <el-form-item label=" " style="display:block;" v-if="roleType == 1">
            <el-checkbox
              v-model="form.schoolCustodian"
              :true-label="1"
              :false-label="0"
            />
            院校管理员
            <div v-if="form.schoolCustodian == 1">
              <el-form-item label="院校" label-width="80px">
                <div class="stationBox">
                  <div class="stationTop">
                    <el-checkbox
                      :indeterminate="isIndeterminateSchool"
                      v-model="checkAllShool"
                      @change="CheckAllSchoolFN"
                      >全选</el-checkbox
                    >
                    <div class="searchCourse ml30">
                      <el-input
                        placeholder="快捷搜索"
                        v-model="schoolStr"
                      ></el-input>
                      <div class="searchPos">
                        <i class="iconfont icon-sousuo"></i>
                      </div>
                    </div>
                  </div>
                  <div class="station-container">
                    <el-checkbox-group
                      v-model="form.school"
                      @change="CheckedSchools"
                    >
                      <el-checkbox
                        v-for="school in schoolDataList"
                        :label="school.id"
                        :key="school.id"
                        :title="school.name"
                        >{{ school.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getCommonInfo } from "@/http/modules/common/privilege";
import { addNoticeFn, editNoticeFn } from "@/http/modules/notice/notice";
import { selectNoticeByIdInfo } from "@/http/modules/student/notice";
import VueUeditorWrap from "vue-ueditor-wrap";
import {
  getSinglePlan,
  getCurrentPlanFn,
} from "@/http/modules/examSet/examBatch";

const payData = [
  {
    name: "全部",
    id: 0,
  },
  {
    name: "已缴费",
    id: 5,
  },
  {
    name: "未缴费",
    id: 1,
  },
  {
    name: "已退费",
    id: 2,
  }
];
export default {
  name: "addNotice",
  components: { VueUeditorWrap },
  data() {
    return {
      defaultTime: "23:59:59",

      // 学生--教学点
      isIndeterminate: true,
      checkAll: false,
      studentStationStr: "",
      // 学生--院校
      isIndeterminateStudentSchool: true,
      checkAllStudentSchool: false,
      studentSchoolStr: "",
      // 教学点
      isIndeterminateStation: true,
      checkAllStation: false,
      stationStr: "",
      // 院校
      isIndeterminateSchool: true,
      checkAllShool: false,
      schoolStr: "",

      test: true,
      saveMethods: "publishNotice",
      backMethods: "saveCaogao",
      cancelName: "保存草稿",
      okName: "发布",
      dataFormat: "yyyy-MM-dd HH:mm:ss",
      form: {
        // 标题
        title: "",
        // 缴费情况
        payStatus: 0,
        // 审核状态
        auditStatus: 0,
        // 学生(默认选中)
        student: 1,
        // 学生--院校id
        studentSchool: [],
        // 学生--教学点id
        studentDealStation: [],
        // 考试批次
        examBatch: "",
        // 有效期开始时间
        validStartDate: "",
        // 有效期结束时间
        validEndDate: "",
        // 公告显示方式
        noticeShow: 0,
        // 富文本内容
        content: "",
        // 院校管理员选中
        schoolCustodian: 0,
        // 院校 id
        school: [],
        // 教学点管理员选中
        dealStationCustodian: 0,
        // 教学点 id
        dealStation: [],
      },
      rules: {
        title: [
          { required: true, message: "请填写标题", trigger: "blur" },
          { min: 1, max: 40, message: "最多可输入40个字", trigger: "blur" },
        ],
        validStartDate: [
          { required: true, message: "请选择有效开始时间", trigger: "change" },
        ],
        validEndDate: [
          { required: true, message: "请选择有效截止时间", trigger: "change" },
          { validator: this.testEndTime, trigger: "change" },
        ],
        content: [{ required: true, message: "请填写内容", trigger: "blur" }],
        studentDealStation: [
          { required: true, message: "请选择教学点", trigger: "blur" },
        ],
        studentSchool: [
          { required: true, message: "请选择院校", trigger: "blur" },
        ],
      },
      // 批次下拉列表
      planData: [],
      // 教学点下拉列表
      stationData: [],
      // 院校下拉列表
      schoolData: [],
      // 审核状态下拉列表
      auditData: [{ name: "全部", id: 0 }],
      // 缴费情况下拉列表
      payData: payData,
      // 有效时间范围
      pickerOptions: {
        disabledDate: (time) => {
          return time < Date.now();
        },
      },
      // 是否启用审核状态/缴费情况
      isUseAudit: true,
      // 当前用户权限
      roleType: "",
      // 是否禁用院校
      disSchool: true,
      // 是否禁用教学点
      disStation: true,
      // 是否禁用学生
      disStudent: true,
    };
  },
  watch: {
    // 修改审核状态下拉列表
    "form.examBatch": function(val) {
      this.changeAuditStatus();
    },

    // 登录页公告：不验证教学点、院校
    "form.noticeShow": function(val) {
      this.rules.studentSchool[0].required = val == 3 ? false: true
      this.rules.studentDealStation[0].required = val == 3 ? false: true
    }
  },
  computed: {
    /*********************
     * @this 返回学生--教学点列表
     *********************/
    stationSelectData() {
   
      if (this.studentStationStr) {
        return this.stationData.filter(
          (item) => item.name.indexOf(this.studentStationStr) > -1
        );
      }
      return this.stationData;
     
    },

    /*********************
     * @this 返回学生--院校列表
     *********************/
    schoolSelectData() {
      if (this.studentSchoolStr) {
        return this.schoolData.filter(
          (item) => item.name.indexOf(this.studentSchoolStr) > -1
        );
      }
      return this.schoolData;
    },

    /*********************
     * @this 返回教学点列表
     *********************/
    stationDataList() {
      if (this.stationStr) {
        return this.stationData.filter(
          (item) => item.name.indexOf(this.stationStr) > -1
        );
      }
      return this.stationData;
    },

    /*********************
     * @this 返回院校列表
     *********************/
    schoolDataList() {
      if (this.schoolStr) {
        return this.schoolData.filter(
          (item) => item.name.indexOf(this.schoolStr) > -1
        );
      }
      return this.schoolData;
    },

    /*********************
     * @this 判断当前操作
     *********************/
    isEditPage() {
      return this.$route.name == "editNotice";
    },

    /*********************
     * @this 选择一直弹窗时,添加提示
     *********************/
    isShowNoticeTip: {
      get() {
        return this.form.noticeShow == 2;
      },
      set(v) {},
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),

    changeStudent(val) {
      if (val == 1) {
        this.disStudent = true;
        this.rules.studentDealStation[0].required = true;
        this.rules.studentSchool[0].required = true;
      } else {
        this.disStudent = false;
        this.rules.studentDealStation[0].required = false;
        this.rules.studentSchool[0].required = false;
      }
    },

    /*******************************
     * @this 学生--教学点全选
     *******************************/
    CheckAllStudentStation(val) {
      // 1. 获取所有教学点id
      let allData = this.stationSelectData.map((item) => item.id);
      // 2. 判断全选是否选中
      this.form.studentDealStation = val ? allData : [];
      // 3. 全选按钮样式控制
      this.isIndeterminate = false;
    },

    /*******************************
     * @this 学生--教学点变更
     *******************************/
    CheckedStudentStations(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.stationSelectData.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.stationSelectData.length;
    },

    /*******************************
     * @this 学生--院校全选
     *******************************/
    CheckAllStudentSchoolFN(val) {
      let allData = this.schoolSelectData.map((item) => item.id);
      this.form.studentSchool = val ? allData : [];
      this.isIndeterminateStudentSchool = false;
    },

    /*******************************
     * @this 学生--院校变更
     *******************************/
    CheckedStudentSchools(value) {
      let checkedCount = value.length;
      this.checkAllStudentSchool =
        checkedCount === this.schoolSelectData.length;
      this.isIndeterminateStudentSchool =
        checkedCount > 0 && checkedCount < this.schoolSelectData.length;
    },

    /*******************************
     * @this 教学点管理员(全选)
     *******************************/
    CheckAllStationFN(val) {
      let allData = this.stationDataList.map((item) => item.id);
      this.form.dealStation = val ? allData : [];
      this.isIndeterminateStation = false;
    },

    /*******************************
     * @this 教学点管理员(变更)
     *******************************/
    CheckedStations(value) {
      let checkedCount = value.length;
      this.checkAllStation = checkedCount === this.stationDataList.length;
      this.isIndeterminateStation =
        checkedCount > 0 && checkedCount < this.stationDataList.length;
    },

    /*******************************
     * @this 院校管理员(全选)
     *******************************/
    CheckAllSchoolFN(val) {
      let allData = this.schoolDataList.map((item) => item.id);
      console.log(allData)
      this.form.school = val ? allData : [];
      this.isIndeterminateSchool = false;
    },

    /*******************************
     * @this 院校管理员(变更)
     *******************************/
    CheckedSchools(value) {
      let checkedCount = value.length;
      this.checkAllSchool = checkedCount === this.schoolDataList.length;
      this.isIndeterminateSchool =
        checkedCount > 0 && checkedCount < this.schoolDataList.length;
    },

    /**************************************
     * @this 随着考试批次修改,设置不同审核状态
     * @id null全部、1待初审、2初审不通过、3待终核、4终审通过、5终审不通过
     **************************************/
    changeAuditStatus() {
      // 每次切换批次时, 审核状态重置为全部 -第一次绑定值不执行
      if (this.isNoFirst) {
        this.form.auditStatus = 0;
      }
      this.isNoFirst = true;
      // 1. 获取选中批次 id
      let planId = this.form.examBatch;
      // 2. 选中全部批次
      if (planId == "00") {
        // 全部考试批次, 禁用审核状态, 禁用缴费情况
        this.isUseAudit = true;
        // 禁用审核状态
        // this.form.auditStatus = 0;
        // 禁用缴费情况
        this.form.payStatus = 0;
        this.auditData = [{ name: "全部", id: 0 }];
      } else {
        // 3. 选中考试批次, 启用审核状态, 启用缴费情况
        this.isUseAudit = false;
        // 4. 根据选中批次修改审核状态
        getSinglePlan({ planId }).then((res) => {
          if (res.code == 1) {
            if (res.data.needAudit == 1) {
              // 每次切换批次时, 审核状态重置为全部
              this.auditData = [
                { name: "全部", id: 0 },
                { name: "待终审", id: 3 },
                { name: "终审通过", id: 4 },
                { name: "终审不通过", id: 5 },
              ];
            } else if (res.data.needAudit == 2) {
              // 每次切换批次时, 审核状态重置为全部

              this.auditData = [
                { name: "全部", id: 0 },
                { name: "待初审", id: 1 },
                { name: "初审不通过", id: 2 },
                { name: "待终审", id: 3 },
                { name: "终审通过", id: 4 },
                { name: "终审不通过", id: 5 },
              ];
            } else {
              // 不做审核
              this.auditData = [{ name: "全部", id: 0 }];
            }
          } else {
            this.auditData = [{ name: "全部", id: 0 }];
          }
        });
      }
    },

    /********************************
     * @this : 配置数据
     *******************************/
    initData() {
      /* *** 根据用户权限, 开启不同发送权限 */
      this.mixin_getCommonInfo().then((res) => {
        this.roleType = res.roleType;
        this.disSchool = res.roleType == 2;
        this.disStation = res.roleType == 3;
        if (res.roleType == 2) {
          this.form.student = 1;
          this.form.studentSchool = [];
          this.form.studentSchool[0] = res.schoolId;
        }
        if (res.roleType == 3) {
          this.form.student = 1;
          this.form.studentDealStation = [];
          this.form.studentDealStation[0] = res.stationId;
        }
      });

      /* *** 考试批次列表 *** */
      this.mixin_getSelectPlan().then((data) => {
        if (data) {
          this.planData = [
            {
              name: "全部",
              id: "00",
            },
          ].concat(data);
        }
      });

      /* *** 添加:获取当前批次 *** */
      // getCurrentPlanFn({
      //   planId: this.form.examBatch,
      // }).then((data) => {
      //   if (!this.isEditPage) {
      //     this.form.examBatch = data.id;
      //   }
      // });

      /* *** 获取教学点列表 *** */
      this.mixin_getSelectStation().then((data) => {
        if (data) {
          this.stationData = data;
        }
      });

      /* *** 获取院校列表 *** */
      this.mixin_getSelectSchool().then((data) => {
        if (data) {
          this.schoolData = data;
        }
      });

      /* *** 修改 : 设置默认数据/数据处理 *** */
      if (this.isEditPage) {
        let { id } = this.$route.query;
        selectNoticeByIdInfo({ id }).then(({ data }) => {
          if (data) {
            for (let key in this.form) {
              this.form[key] = data[key];
            }
            this.form.studentDealStation = data.studentDealStation
              ? data.studentDealStation.split(",")
              : [];
            this.form.studentSchool = data.studentSchool
              ? data.studentSchool.split(",")
              : [];
            this.form.dealStation = data.dealStation
              ? data.dealStation.split(",")
              : [];
            this.form.school = data.school ? data.school.split(",") : [];
            this.disStudent = this.form.student == 1;
          }
        });
      }
    },

    /********************************
     * @this : 编辑/添加公告功能
     *******************************/
    commonForm(obj) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = Object.assign(this.form, obj);
          const dealFn = this.isEditPage ? editNoticeFn : addNoticeFn;
          if (this.isEditPage) {
            params.id = this.$route.query.id;
          }
          // 多选列表 数组 => 字符串
          params.studentDealStation = this.form.studentDealStation.join();
          params.studentSchool = this.form.studentSchool.join();
          params.dealStation = this.form.dealStation.join();
          params.school = this.form.school.join();
          dealFn(params).then(({ data, code }) => {
            if (code == 1) {
              this.$message.success("操作成功");
              this.$router.go(-1);
            } else {
              // 未成功,将字符串 => 数组
              params.studentDealStation = this.form.studentDealStation.split(
                ","
              );
              params.studentSchool = this.form.studentSchool.split(",");
              params.dealStation = this.form.dealStation.split(",");
              params.school = this.form.school.split(",");
            }
          });
        }
      });
    },

    /********************************
     * @this : 编辑/添加公告功能 -- 直接发布
     *******************************/
    publishNotice() {
      this.commonForm({ isIssue: "50" });
    },

    /********************************
     * @this : 编辑/添加公告功能 -- 保存草稿
     *******************************/
    saveCaogao() {
      this.commonForm({ isIssue: "00" });
    },

    /********************************
     * @this : 公告有效时间
     *******************************/
    testEndTime(rule, value, callback) {
      if (value) {
        if (
          new Date(this.form.validStartDate).getTime() >
          new Date(this.form.validEndDate).getTime()
        ) {
          callback(new Error("有效期结束时间必须晚于开始时间！"));
        } else {
          callback();
        }
      }
      callback();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/style/ueditor/css/ueditor.css";
.content {
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
}
/deep/ .el-radio-button__inner {
  margin-right: 8px;
  color: #45494d !important;
  background: #f4f5f8 !important;
  font-size: 13px;
  border-radius: 4px !important;
  border: 1px solid #dadde6 !important;
  padding: 10px 20px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
  box-shadow: none;
}
.editor {
  width: 680px;
}

/* ***** 多选列表 ****** */
.stationBox {
  margin-top: 10px;
  width: 1000px;
  max-height: 300px;
  background-color: #f8f9fc;
  overflow-y: auto;
  padding: 20px;
  border-radius: 8px;
  .stationTop {
    display: flex;
    margin-bottom: 20px;
  }
  .searchCourse {
    position: relative;
    .searchPos {
      width: 40px;
      height: 18px;
      line-height: 18px;
      border-left: 1px solid #e1e6ed;
      position: absolute;
      right: 0;
      top: 11px;
      color: #c2c6cc;
      font-size: 14px;
      i {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
.station-container /deep/ .el-checkbox {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
}
</style>
